import React from 'react';
import PropTypes from 'prop-types';
import { FormField, Label, TextArea } from 'semantic-ui-react';

function ValidatedTextArea({ input, meta: { touched, error }, ...rest }) {
  const errorContent = touched && !!error && error;
  return (
    <FormField error={errorContent}>
      <TextArea {...input} {...rest} />
      {errorContent && <Label prompt content={errorContent} pointing="above" />}
    </FormField>
  );
}

ValidatedTextArea.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool.isRequired,
    error: PropTypes.bool.isRequired,
  }).isRequired,
};

export default ValidatedTextArea;
